import { Link } from "react-router-dom";

const links = {
  boutique: [
    { label: "Collections", to: "/products" },
    { label: "Chaussures", to: "/products/shoes" },
    { label: "Sacs", to: "/products/bags" },
  ],
  service: [
    { label: "Nouveautes", to: "/products/news" },
    { label: "Commander facilement", to: "/products" },
    { label: "Besoin d’aide ?", to: "/products" },
  ],
};

export default function Footer() {
  return (
    <footer className="px-4 pb-8 pt-6 md:px-8 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="surface-panel rounded-[34px] overflow-hidden">
          <div className="grid gap-8 px-6 py-8 md:px-8 md:py-10 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
            <div>
              <p className="brand-eyebrow">Si’Bella Boutique</p>
              <h2 className="brand-display mt-4 text-4xl font-bold leading-tight text-[#221510] md:text-6xl">
                Des pieces choisies pour reveler votre elegance.
              </h2>
              <p className="mt-5 max-w-xl text-sm leading-8 text-[#705a4e]">
                Sacs, chaussures et nouveautes sont reunis dans une boutique
                pensee pour vous inspirer et vous aider a trouver votre prochain
                coup de coeur.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <span className="rounded-full bg-[#241712] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#fff1e5]">
                  Style feminin
                </span>
                <span className="rounded-full bg-[#f0dccd] px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#6f4834]">
                  Belle selection
                </span>
              </div>
            </div>

            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#8d6e5d]">
                Boutique
              </p>
              <div className="mt-5 flex flex-col gap-3">
                {links.boutique.map((item) => (
                  <Link
                    key={item.label}
                    to={item.to}
                    className="text-sm text-[#3d281d] transition hover:text-[#7a3f24]"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#8d6e5d]">
                Infos
              </p>
              <div className="mt-5 flex flex-col gap-3">
                {links.service.map((item) => (
                  <Link
                    key={item.label}
                    to={item.to}
                    className="text-sm text-[#3d281d] transition hover:text-[#7a3f24]"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-[rgba(62,35,24,0.08)] bg-white/55 px-6 py-4 text-xs uppercase tracking-[0.22em] text-[#8d7466] md:flex md:items-center md:justify-between md:px-8">
            <p>© {new Date().getFullYear()} Si’Bella Boutique</p>
            <div className="mt-3 text-right md:mt-0">
              <p>Mode, elegance et belles envies</p>
              <a
                href="https://www.loven-soft.com"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-block text-[10px] tracking-[0.24em] text-[#7a3f24] transition hover:text-[#4f2414]"
              >
                Designed by LSD
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
